import { useMemo } from "react";
import { getSupportedFormatLocale } from "../getSupportedFormatLocale";
export function useLocale(suppliedLocale) {
    return useMemo(() => suppliedLocale || getSupportedFormatLocale("dateTime"), [suppliedLocale]);
}
//# sourceMappingURL=useLocale.js.map